/* eslint-disable no-restricted-imports */
import { ErrorField } from '../../../routing/business/PartnerRegistration/types';

/**
 * Маппинг полей API к полям формы
 * Ключ - поле из API (ErrorField['field'])
 * Значение - имя поля в форме
 */
export const API_TO_FORM_FIELD_MAPPING: Record<string, string> = {
    // SignupExternalPersonal fields -> SE_FIELDS
    first_name: 'firstName',
    last_name: 'lastName',
    patronym: 'patronymic',
    birth_date: 'birthDate',
    pass_number: 'passport',
    issue_date: 'issuedDate',
    issuer_code: 'subdivisionCode',
    issued_by: 'issuedBy',
    legal_address: 'registrationAddress',
    legal_address_postcode: 'index',
    snils: 'snilsNumber',
    inn: 'innOgrn',

    // SignupExternalLegalEntity fields -> IE_FIELDS, LLC_FIELDS
    legal_form: 'taxSystem',
    vat_rate: 'taxSystem',
    business_name: 'name',
    ogrn_or_inn: 'innOgrn',

    // Bank details fields -> BANK_DETAILS_FIELDS
    account_nr: 'accountNumber',
    bik: 'bik',
    bank_name: 'bankName',

    // Signer data fields -> SIGNER_DATA_FIELDS
    full_name: 'fullName',
    position: 'position',
};

/**
 * Получает ошибку для конкретного поля формы из массива ошибок API
 */
export const getFieldError = (errors: ErrorField[], fieldName: string): string | undefined => {
    const error = errors.find((err) => API_TO_FORM_FIELD_MAPPING[err.field] === fieldName);

    return error?.description || undefined;
};

/**
 * Проверяет, есть ли ошибки для полей формы в массиве ошибок API
 */
export const hasFieldErrors = (errors: ErrorField[]): boolean =>
    errors.some((err) => API_TO_FORM_FIELD_MAPPING[err.field]);
